import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2d2611cf")
const _hoisted_1 = { class: "flex-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "ri-menu-line ri-xl" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_heading = _resolveComponent("heading")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.showHeaderMenu)
      ? (_openBlock(), _createBlock(_component_custom_button, {
          key: 0,
          type: "circle",
          style: {"margin-left":"15px"},
          width: 43,
          height: 43,
          centering: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickMenu')))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_heading, {
      level: 1,
      fontSize: "l",
      textAlign: "center",
      isFullWidth: true
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    })
  ]))
}